import React from 'react';
import PropTypes from 'prop-types';

import RegionsListItem from './RegionsListItem';

export function RegionsListComponent({ regions, handleClick }) {
  return (
    <ul className="list-wrapper">
      {regions.map(region => {
        return (
          <RegionsListItem
            key={region.id}
            favoritesType="regions"
            region={region}
            handleClick={handleClick}
          />
        );
      })
      }
    </ul>
  );
}

RegionsListComponent.propTypes = {
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ).isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default RegionsListComponent;



// WEBPACK FOOTER //
// ./src/components/List/Areas/RegionsList.js